import {css} from '../../theme/css'

export const classes = {
  root: css`
    margin: 0;
    width: 100%;
  `,
  maxHeight: css`
    height: 100vh;
  `,
}
